const images = {
  notFoundGif: require("./notfound.gif"),
  MomoQR: require("./MomoQR.jpg"),
  momoPayment: require("./momoPayment.jpg"),
  ZalopayQR: require("./ZalopayQR.jpg"),
  BIDVQR: require("./BIDVQR.jpg"),
  kimcuong: require("./kimcuong.jpg"),
  //Blog:
  blog1: require("./Blog/blog1.png"),
  blog2: require("./Blog/blog2.png"),
  blog3: require("./Blog/blog3.png"),
  cartIsNull: require("./cartNull.png"),
};

export default images;
